import React from 'react'
import { View, ViewPropTypes } from 'react-native'
import { Card as NativeCard } from 'react-native-elements'
import PropTypes from 'prop-types'

import Identity from '../../utils/Identity'
import { styles } from './styles'
import { useTheme } from '../../theming/ThemeProvider'

const Card = ({ children, containerStyle, contentStyle }) => {
  const { theme } = useTheme()
  return (
    <View style={[
      Identity.Shadow(theme).Card,
      containerStyle
    ]}
    >
      <NativeCard containerStyle={[styles.card, contentStyle]}>
        {children}
      </NativeCard>
    </View>
  )
}

Card.propTypes = {
  children: PropTypes.any,
  containerStyle: ViewPropTypes.style,
  contentStyle: ViewPropTypes.style
}

Card.defaultProps = {
  children: null,
  containerStyle: {},
  contentStyle: {}
}

export default Card
